module.exports = __webpack_public_path__ + "img/mint5-rollover.7bb90391.png";